module.exports = __webpack_public_path__ + "static/media/pc-image-background-checker-pattern-red-1.5e8491e0.svg";